module.exports = __webpack_public_path__ + "static/world-solar-9ca7bd3be65ffb419fbd3f03639bb90b.jpg";